import { Pagination } from "@mui/material";
import React from "react";

export default function PaginationComponent({
  count = 10,
  onChangeItem = (value) => {},
  page = 1,
}) {
  const { innerWidth: width, innerHeight: height } = window;
  return (
    <div style={width < 480 ? styles.paginationDivMob : styles.paginationDiv}>
      <Pagination
        color="primary"
        count={count}
        variant="text"
        shape="rounded"
        page={page}
        onChange={(event, value) => onChangeItem(value)}
      />
    </div>
  );
}
const styles = {
  paginationDiv: {
    // position: "fixed",
    width: "90%",
    bottom: 13,
    display: "flex",
    justifyContent: "center",
  },
  paginationDivMob: {
    // position: "absolute",
    width: "100%",
    bottom: 13,
    display: "flex",
    justifyContent: "center",
  },
};
